// extracted by mini-css-extract-plugin
export default {"fs":"_4a6cd59b0a ec0332d875"};